import Vue from 'vue'
import Vuex from 'vuex'
import account from './modules/account'
import customer from './modules/customer'
import getters from '@/store/getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    account,
    customer,
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js